import StylingBackgrounds from './StylingBackgrounds'

export default StylingBackgrounds
